import _toConsumableArray from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import AccordionContext from "../context";
var Provider = AccordionContext.Provider;
export var Wrapper = function Wrapper(_ref) {
  var _ref$allowMultipleOpe = _ref.allowMultipleOpened,
      e = _ref$allowMultipleOpe === void 0 ? !1 : _ref$allowMultipleOpe,
      _ref$scrollToOpenedCo = _ref.scrollToOpenedContent,
      t = _ref$scrollToOpenedCo === void 0 ? !1 : _ref$scrollToOpenedCo,
      _ref$openChild = _ref.openChild,
      o = _ref$openChild === void 0 ? "" : _ref$openChild,
      n = _ref.children,
      r = _ref.onChange;

  var _useState = useState(e ? [] : ""),
      _useState2 = _slicedToArray(_useState, 2),
      c = _useState2[0],
      l = _useState2[1];

  useEffect(function () {
    l(o);
  }, [o]);
  var s = useCallback(function (t) {
    if (e) {
      if ("object" == typeof c && c.includes(t)) {
        var _e = null == c ? void 0 : c.filter(function (e) {
          return e !== t;
        });

        l(_e);
      } else l(function (e) {
        return [].concat(_toConsumableArray(e), [t]);
      });
    } else l(c === t ? "" : t);
  }, [c, l, e]),
      u = useMemo(function () {
    return {
      openedItems: c,
      setOpenedItems: l,
      openElement: s,
      scrollToOpenedContent: t
    };
  }, [c, l, s, t]),
      i = useRef(!0);
  return useEffect(function () {
    !(null == i ? void 0 : i.current) && r && r(c), i.current = !1;
  }, [i, c, r]), React.createElement(Provider, {
    value: u
  }, void 0 !== n && "function" == typeof n ? n(u) : n);
};
export default React.memo(Wrapper);